import { render } from "./EmployeeProject.vue?vue&type=template&id=c466dea6"
import script from "./EmployeeProject.vue?vue&type=script&lang=js"
export * from "./EmployeeProject.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__